// Gradient-Matrix login with colorful code rain
import React, { useState } from 'react';
import { login } from '../../controllers/PasswordsController';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login({ setUser }) {
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    
    const handleLogin = async (e) => {
        e.preventDefault();
        if (!password) {
            setError('Veuillez entrer un mot de passe.');
            return;
        }
        setIsLoading(true);
        setError('');

        try {
            const response = await login(password);
            if (response && response.success) {
                setUser({ isAuthenticated: true });
                navigate('/data');
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setError('Mot de passe incorrect.');
            } else {
                setError('Une erreur est survenue. Veuillez réessayer.');
            }
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div className="gradient-matrix-container">
            {/* Colorful matrix rain */}
            <div className="colorful-matrix-rain"></div>
            
            {/* Glowing center card */}
            <div className="cyber-card">
                <h2 className="holographic-title">
                    <span data-text="AUTH">AUTH</span>
                    <span className="blink" data-text="_">_</span>
                </h2>
                
                <div className="input-wrapper">
                    <input
                        type="password"
                        placeholder="Enter Access Code"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={isLoading}
                        className="neon-input"
                    />
                    <div className="input-highlight"></div>
                </div>
                
                {error && (
                    <div className="glitch-error">
                        <div className="error-pulse">⚠</div>
                        {error}
                    </div>
                )}
                
                <button 
                    onClick={handleLogin}
                    disabled={isLoading}
                    className="holographic-button"
                >
                    {isLoading ? (
                        <span className="loading-bars">
                            <span></span>
                            <span></span>
                            <span></span>
                            DECRYPTING...
                        </span>
                    ) : (
                        'ACCESS TERMINAL'
                    )}
                </button>
                
                <div className="cyber-grid-lines"></div>
                <div className="corner-dots tl"></div>
                <div className="corner-dots tr"></div>
                <div className="corner-dots bl"></div>
                <div className="corner-dots br"></div>
            </div>
        </div>
    );
}

export default Login;